// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1gdK_","itemTitle":"ClientEmergencyInfo_itemTitle___kvKz","itemText":"ClientEmergencyInfo_itemText__MT1kL"};